import { render, staticRenderFns } from "./ComunicationEdit.vue?vue&type=template&id=299b5192"
import script from "./ComunicationEdit.vue?vue&type=script&lang=js"
export * from "./ComunicationEdit.vue?vue&type=script&lang=js"
import style0 from "./ComunicationEdit.vue?vue&type=style&index=0&id=299b5192&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports